const FranceFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="10" height="20" fill="#002654"/>
    <rect x="10" width="10" height="20" fill="#FFFFFF"/>
    <rect x="20" width="10" height="20" fill="#ED2939"/>
  </svg>
);

export default FranceFlag;